<template>
  <v-chip x-small label :class="chipClass">
    {{ label }}
  </v-chip>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
  },
  computed: {
    label() {
      const status = this.item?.__assignmentStatus ?? this.item?.status ?? null;
      if (!status) return "not assigned";
      return status;
    },
    chipClass() {
      const status = this.item?.__assignmentStatus ?? this.item?.status ?? null;
      if (status === "done") return "green lighten-4";
      if (status === "open") return "blue lighten-4";
      if (status === "assigned") return "grey lighten-3";
      return "grey lighten-4";
    },
  },
};
</script>
